import { render, staticRenderFns } from "./BannerProHot.vue?vue&type=template&id=6476705f&scoped=true"
import script from "./BannerProHot.vue?vue&type=script&lang=js"
export * from "./BannerProHot.vue?vue&type=script&lang=js"
import style0 from "./BannerProHot.vue?vue&type=style&index=0&id=6476705f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6476705f",
  null
  
)

export default component.exports